/*
|--------------------------------------------------------------------------
|  Navigation  start
|--------------------------------------------------------------------------
|
|
*/

$('body').click(function(event)
{
    if(  $('body').hasClass('slideout') )
    {
        $('body').removeClass('slideout');
    }

    if(  $('body').hasClass('slideout-firmCategory') )
    {
        $('body').removeClass('slideout-firmCategory');
    }
});

$('nav a.modal-close.navigation-close').on('click', function() {
  $('body').removeClass('slideout');
  $('body').removeClass('slideout-firmCategory');
});


$('.nav-content--sm ').click(function(event)
{
    event.stopPropagation();
});

$('.link-reset').click(function(event)
{
    $('body').addClass('slideout');
    event.stopPropagation();
});

$('.link-reset-firmCategory').click(function(event)
{
    $('body').addClass('slideout-firmCategory');
    event.stopPropagation();
});


// open small navigation
function openSearchModal(){
    $('#search-modal--sm').modal()
}


$('body.search-page .text-more-filters').click(function()
{
    showFilters()
});

$('body.search-page .search-button').click(function()
{
    hideFilters()
});

$('body.search-page .js-small-filters-close').click(function(){
    hideFilters()
});

$('body.search-page .js-small-filter-toggle').click(function()
{
    showFilters()
});

function showFilters()
{
    $('body.search-page .filters').removeClass('collapse')
    $('.sidebar').addClass('filters-open');
    //$('.show-more').trigger('click');

    if($('body').hasClass('search-page-firms-c1'))
    {
        $('.filters-more').removeClass('collapse');
    }

}

function hideFilters()
{
    $('body.search-page .filters').addClass('collapse')
    $('.sidebar').removeClass('filters-open');
    //$('.show-more').trigger('click');
    $('.filters-more').addClass('collapse');
}

$('body.search-page .filters-section .show-more').click(function()
{
    $(this).parent().parent().find( "div.filters-more" ).toggleClass('collapse')
});


$("body.search-page .footer-toggle").click(function(){
    $(this).toggleClass("open");
    $('body.search-page .footer-container').toggle();
});


$("#how-it-works-trigger").click(function(){
    $('.how-it-work-container').removeClass('hide');
});

$('#how-it-work-close').click(function(){
    $('.how-it-work-container').addClass('hide');
});


// keyword text on homepage
$('.textAccordionKeywords h5').click(function(){

    var key = $(this).data().keytextaccordion ;

    $('.textAccordionKeywords h5.active').removeClass('active');
    $(this).addClass('active');

    $('.textAccordionDescriptions div').attr('style','height:0px');
    $('.textAccordionDescriptions div[data-textAccordion="'+key+'"]').attr('style','height:auto');
});

//// CHANGE IMAGE
function changeImagePrevNext()
{

    $('.target-next').click(function ()
    {
        var img = $(this).parent().find('img')
        var imgAll    =  img.data().images
        var current   =  img.data().current ;


        if( current + 1 >= imgAll.length  )
        {
            var num = 0
        }
        else
        {
            var num = current + 1
        }

        $(img).attr('src',imgAll[num])
        $(img).data().current = num

    });

    $('.target-prev').click(function () {
        var img = $(this).parent().find('img')
        var imgAll    =  img.data().images
        var current   =  img.data().current  ;

        if( current - 1 == -1  )
        {
            var num = imgAll.length - 1
        }
        else
        {
            var num = current - 1
        }

        $(img).attr('src',imgAll[num])
        $(img).data().current = num

    });
}
//// CHANGE IMAGE
function changeImagePrevNextInfoWindow()
{
    $('.target-next-infowindow').click(function ()
    {
        var img = $(this).parent().find('img')
        var imgAll    =  img.data().images
        var current   =  img.data().current ;


        if( current + 1 >= imgAll.length  )
        {
            var num = 0
        }
        else
        {
            var num = current + 1
        }

        $(img).attr('src',imgAll[num])
        $(img).data().current = num

    });

    $('.target-prev-infowindow').click(function () {
        var img = $(this).parent().find('img')
        var imgAll    =  img.data().images
        var current   =  img.data().current  ;

        if( current - 1 == -1  )
        {
            var num = imgAll.length - 1
        }
        else
        {
            var num = current - 1
        }

        $(img).attr('src',imgAll[num])
        $(img).data().current = num

    });
}

changeImagePrevNext()

//
//$('.target-next').click(function () {
//    var img = $(this).parent().find('img')
//    var imgAll    =  img.data().images
//    var current   =  img.data().current ;
//
//
//    if( current + 1 >= imgAll.length  )
//    {
//        var num = 0
//    }
//    else
//    {
//        var num = current + 1
//    }
//
//    $(img).attr('src',imgAll[num])
//    $(img).data().current = num
//
//});
//
//$('.target-prev').click(function () {
//    var img = $(this).parent().find('img')
//    var imgAll    =  img.data().images
//    var current   =  img.data().current  ;
//
//    if( current - 1 == -1  )
//    {
//        var num = imgAll.length - 1
//    }
//    else
//    {
//        var num = current - 1
//    }
//
//    $(img).attr('src',imgAll[num])
//    $(img).data().current = num
//
//});

// $( ".singleApartment" ).hover(
//     function() {
//         $(this).find('.target-control').css('opacity','1');
//     }, function() {
//         $(this).find('.target-control').css('opacity','0');
//     }
// );


/*
 |--------------------------------------------------------------------------
 |  DATEPICKER , PRICE RANGE
 |--------------------------------------------------------------------------
 |
 |
 */



function clearDates()
{
    $('#checkin').val('')
    $('#checkout').val('')
    $('#checkin').trigger('change')
    $('#checkout').trigger('change')

    $('.pricesTableForm').css('display','none')
}

function clearDatesBig()
{
    $('#checkinBig').val('')
    $('#checkoutBig').val('')
    $('#checkinBig').trigger('change')
    $('#checkoutBig').trigger('change')

    if ($('.pricesTableForm')) {
        if ($('#guests') && $('#guests').val()) {
            showDefaultPrice($('#guests').val());
        } else {
            $('.pricesTableForm').hide();
        }
    }
}

function clearDatesSmall()
{
    $('#checkinSmall').val('')
    $('#checkoutSmall').val('')
    $('#checkinSmall').trigger('change')
    $('#checkoutSmall').trigger('change')

    $('.pricesTableForm').css('display','none')
}

$(function() {
    window.currentLocale = $('html').attr('lang') === 'en'
      ? 'en'
      : 'sr';

    var dayNamesTranslated = window.currentLocale === 'en'
      ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      : ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'];

    var monthNamesTranslated = window.currentLocale === 'en'
      ? [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
      : [ "Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar" ];

    var clearDatesTranslated = window.currentLocale === 'en'
      ? 'Clear Dates'
      : 'Obriši Datume';

    $( "#checkout" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
        beforeShow: function(input, inst) {
            if( $( "#checkin").val() == '' )
            {
                $( "#checkin" ).datepicker("show")
                return false;
            }
            return true;
        },
    })
    .on( "click", function() {
        $('.searchClearDates').remove();
        $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDates()">' + clearDatesTranslated + '</span>');
    });

    // Datepicker
    $( "#checkin" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
        onSelect: function (selectedDate, inst) {
            var d = $.datepicker.parseDate(inst.settings.dateFormat, selectedDate);
            d.setDate(d.getDate() + 1);
            var newDate2 = $.datepicker.formatDate(inst.settings.dateFormat, d);
            $("#checkout").val(  newDate2  );
            $( "#checkout" ).datepicker( "option", "minDate", newDate2 );

        },
        onClose: function ()
        {

            $( "#checkout" ).datepicker( "show");
        },
    })
    .on( "click", function() {
        $('.searchClearDates').remove();
        $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDates()">' + clearDatesTranslated + '</span>');
    });

    $( "#checkin" ).attr( 'autocomplete', 'off');
    $( "#checkout" ).attr( 'autocomplete', 'off');

    //////////////////////////////////////////////////////
    //      This is for small screen same as above  just different ID - if you change anything above or belove - copy paste code and change selector
    //////////////////////////////////////////////////////
    // var disableddates = [ "14-11-2017", "15-11-2017","05-12-2017", "06-12-2017"];
    // function DisableSpecificDates(date) {
    //     var string = jQuery.datepicker.formatDate('dd-mm-yy', date);
    //     return [disableddates.indexOf(string) == -1];
    // }
    $( "#checkoutBig" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
        onSelect: function (selectedDate, inst)
        {
            priceCalculator();
        },
        beforeShow: function(input, inst) {
            if( $( "#checkinBig").val() == '' )
            {
                $( "#checkinBig" ).datepicker("show")
                return false;
            }
            else {
                var checkinDate = $.datepicker.parseDate(inst.settings.dateFormat, $('#checkinBig').val());
                checkinDate.setDate(checkinDate.getDate() + 1);
                var minDate = $.datepicker.formatDate(inst.settings.dateFormat, checkinDate);
                $("#checkoutBig").datepicker("option", "minDate", minDate);
            }
            return true;
        }
    })
    .on( "click", function() {
        if (typeof setTooltipOnCalendar == 'function') {
            setTooltipOnCalendar();
        }
        $('.searchClearDates').remove();
        $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDatesBig()">' + clearDatesTranslated + '</span>');
    });


    // Datepicker
    $( "#checkinBig" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
        onSelect: function (selectedDate, inst) {
            // priceCalculator();

            var d = $.datepicker.parseDate(inst.settings.dateFormat, selectedDate);
            d.setDate(d.getDate() + 1);
            var newDate2 = $.datepicker.formatDate(inst.settings.dateFormat, d);

            $("#checkoutBig").val(  newDate2  );
            $("#checkoutBig" ).datepicker( "option", "minDate", newDate2 );
            // ako postoji funkcija pozovi je ”””
            if (typeof updateCheckOut == 'function')
            {
                var e = $.datepicker.parseDate(inst.settings.dateFormat, selectedDate);
                e.setDate(e.getDate() );
                updateCheckOut( $.datepicker.formatDate('dd-mm-yy', e));
            }
        },
        onClose: function ()
        {
            $( "#checkoutBig" ).datepicker( "show");
            if (typeof setTooltipOnCalendar == 'function') {
                setTooltipOnCalendar();
            }
        },
    })
        .on( "click", function() {
            if (typeof setTooltipOnCalendar == 'function') {
                setTooltipOnCalendar();
            }
            $('.searchClearDates').remove();
            $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDatesBig()">' + clearDatesTranslated + '</span>');
        });

    $( "#checkinBig" ).attr( 'autocomplete', 'off');
    $( "#checkoutBig" ).attr( 'autocomplete', 'off');

    //////////////////////////////////////////////////////
    //      This is for small screen same as above  just different ID - if you change anything above or belove - copy paste code and change selector
    //////////////////////////////////////////////////////

    $( "#checkoutSmall" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
    })
    .on( "click", function() {
        $('.searchClearDates').remove();
        $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDatesSmall()">' + clearDatesTranslated + '</span>');
    });
    // Datepicker
    $( "#checkinSmall" ).datepicker({
        minDate : 'today',
        prevText: "",
        nextText: "",
        dateFormat: 'yy-mm-dd',
        firstDay: 1,
        dayNamesMin: dayNamesTranslated,
        monthNames: monthNamesTranslated,
        onSelect: function (selectedDate, inst) {
            var d = $.datepicker.parseDate(inst.settings.dateFormat, selectedDate);
            d.setDate(d.getDate() + 1);
            var newDate2 = $.datepicker.formatDate(inst.settings.dateFormat, d);
            $("#checkoutSmall").val(  newDate2  );
            $( "#checkoutSmall" ).datepicker( "option", "minDate", newDate2 );


        },
        onClose: function ()
        {

            $( "#checkoutSmall" ).datepicker( "show");
        },
    })
        .on( "click", function() {
            $('.searchClearDates').remove();
            $('.ui-datepicker-calendar').after('<span class="middle searchClearDates" onclick="clearDatesSmall()">' + clearDatesTranslated + '</span>');
        });

    $( "#checkinSmall" ).attr( 'autocomplete', 'off');
    $( "#checkoutSmall" ).attr( 'autocomplete', 'off');
});


$('input[name="parking-checkbox"]').on('change', function() {
    priceCalculator();
});

/*
 |--------------------------------------------------------------------------
 |  Price Calculator - for single apartment
 |--------------------------------------------------------------------------
 |
 |
 */

function priceCalculator()
{
    if(!$.prices){
        return;
    }

    var guests = $("#guests").val();
    if( $('.singleApartmentContainerWrapper #checkinBig').val() != ''  && $('.singleApartmentContainerWrapper #checkoutBig').val() != ''  &&
        typeof $('.singleApartmentContainerWrapper #checkinBig').val() != 'undefined'  && typeof $('.singleApartmentContainerWrapper #checkoutBig').val() != 'undefined' )
    {
        var checkoutParkingSelected = false;
        var checkoutParkingCheckbox = $('input[name="parking-checkbox"]');
        if (checkoutParkingCheckbox && checkoutParkingCheckbox.is(':checked')) {
          checkoutParkingSelected = true;
        }

        var priceRequestParams = {
            id: $.apartment_id,
            checkin: $( "#checkinBig").val(),
            checkout: $( "#checkoutBig").val(),
            guests: guests,
            parking: checkoutParkingSelected,
        };
        req = $.post('/api/apartments/calculate-price', priceRequestParams, function (data) {
            var pricePerDay = data.price_per_day_rounded ? data.price_per_day_rounded : data.price_per_day;

            $('.pricesTableForm').show();
            $('#priceTable-days').html( data.days );
            $('#priceTable-pricePerDay').html( pricePerDay );
            $('#pricePerNightHeader').html( pricePerDay );
            $('#priceTable-total').html( data.price_total );
            $('#priceTable-total2').html( data.apartment_total );

            if (data.overlap_with_new_year_period && data.new_year_price_per_day && data.new_year_price_total) {
                $('#newYearPriceDescription').show();
                $('#priceDescription').hide();

                $('.new-year-price-per-day').html(data.new_year_price_per_day);
                $('#new-year-price-total').html(data.new_year_price_total);
            } else {
                $('#newYearPriceDescription').hide();
                $('#priceDescription').show();
            }

            if (checkoutParkingSelected) {
                $('.priceTable-parking').show();
                $('#priceTable-days2').html( data.days );
                $('.priceTable-parking-total').html( data.parking_total );
            } else {
                $('.priceTable-parking').hide();
            }

            if (data.price_per_day_rounded) {
                $('#averagePriceTooltip').show();
            } else {
                $('#averagePriceTooltip').hide();
            }

            updatePricingPreview(data.base_price_per_day, pricePerDay, data.weekend_extra_price, data.days, data.price_total, checkoutParkingSelected, data.parking_total);
            $('.pricing-preview-link').show();
        })
        .fail(function() {
            showDefaultPrice(guests);
        });
    }
    else
    {
        showDefaultPrice(guests);
    }
}

function showDefaultPrice(guests) {
    $('#pricePerNightHeader').html( $.prices[guests-1]['1_3'] );
    $('.pricing-preview-link').hide();
    $('.pricesTableForm').hide();
}

function updatePricingPreview(basePricePerDay, averagePricePerDay, weekendExtraPrice, days, total, checkoutParkingSelected, parkingTotal) {
    var pricingPreviewHtml = '';
    if (days < 16) {
      var startDate = new Date($('#checkinBig').val());
      var endDate = new Date($('#checkoutBig').val());
      var currentDate = new Date(startDate);

      while (currentDate < endDate) {
          var dayPrice = basePricePerDay;
          if (weekendExtraPrice && weekendExtraPrice > 0 && (currentDate.getDay() === 5 || currentDate.getDay() === 6)) {
            dayPrice += weekendExtraPrice;
          }

          pricingPreviewHtml += '<div class="pricing-preview-item">';
          pricingPreviewHtml += '<span class="date">' + currentDate.toISOString().split('T')[0] + '</span>';
          pricingPreviewHtml += '<span class="price">€' + dayPrice + '</span>';
          pricingPreviewHtml += '</div>';
          currentDate.setDate(currentDate.getDate() + 1);
      }

      if (checkoutParkingSelected) {
          pricingPreviewHtml += '<div class="pricing-preview-item">';
          pricingPreviewHtml += '<span class="date">Parking ' + (window.currentLocale == 'sr' ? 'ukupno' : 'total') + '</span>';
          pricingPreviewHtml += '<span class="price">€' + parkingTotal + '</span>';
          pricingPreviewHtml += '</div>';
      }

      pricingPreviewHtml += '<div class="pricing-preview-total">';
      pricingPreviewHtml += '<span class="date">' + (window.currentLocale == 'sr' ? 'Ukupna cena' : 'Total Price') + '</span>';
      pricingPreviewHtml += '<span class="price">€' + total + '</span>';
    }
    else {
      pricingPreviewHtml = days + (window.currentLocale == 'sr' ? ' dana' : ' nights')
          + (window.currentLocale == 'sr' ? ' po' : ' at')
          + ' <strong>€' + averagePricePerDay + '</strong>' + (window.currentLocale == 'sr' ? ' po danu.' : ' per night.');

      if (checkoutParkingSelected) {
        pricingPreviewHtml += (window.currentLocale == 'sr' ? ' Ukupna cena za parking je' : ' Total price for parking is') + ' <strong>€' + parkingTotal + '</strong>.';
      }
      pricingPreviewHtml += (window.currentLocale == 'sr' ? ' Ukupna cena koju plaćate je' : ' Total price you pay is') + ' <strong>€' + total + '</strong>.';
      pricingPreviewHtml += (window.currentLocale == 'sr' ? ' Prosečna cena po danu je zaokružena.' : ' Average price per night is rounded.');
    }

    $('.pricing-preview-content').html(pricingPreviewHtml);
}

/*
|--------------------------------------------------------------------------
|  Wish list
|--------------------------------------------------------------------------
|
|
*/

$(function() {

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        var _OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
            window.Cookies = _OldCookies;
            return api;
        };
    }
}(function () {
    function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[ i ];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function init (converter) {
        function api (key, value, attributes) {
            var result;

            // Write

            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);

                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }

                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}

                value = encodeURIComponent(String(value));
                value = value.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);

                return (document.cookie = [
                    key, '=', value,
                    attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
                    attributes.path    && '; path=' + attributes.path,
                    attributes.domain  && '; domain=' + attributes.domain,
                    attributes.secure ? '; secure' : ''
                ].join(''));
            }

            // Read

            if (!key) {
                result = {};
            }

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;

            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var name = parts[0].replace(rdecode, decodeURIComponent);
                var cookie = parts.slice(1).join('=');

                if (cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }

                try {
                    cookie = converter && converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }

                    if (key === name) {
                        result = cookie;
                        break;
                    }

                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }

            return result;
        }

        api.get = api.set = api;
        api.getJSON = function () {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };

        api.withConverter = init;

        return api;
    }

    return init();
}));

});

$(function()
{
    // get init wishlist
    $.wishlist      = Cookies.getJSON('wishlist');
    $.wishlistFirms = Cookies.getJSON('wishlistFirms');

    if(
        ($.wishlist && $.wishlist.length ) || ($.wishlistFirms && $.wishlistFirms.length )
       )
    {
        wishlistTotalCount();
        $('.WishlistBtn').css('left','0');
        $('.WishlistBtn').show();
    }
    else
    {
        wishlistTotalCount();
        $('.WishlistBtn').hide();

    }

});




/*
|--------------------------------------------------------------------------
|  Wishlist
|--------------------------------------------------------------------------
|////https://github.com/js-cookie/js-cookie
|
*/

//function wishlist(ovo)
//{
//    //var id = parseInt(id);
//    var addOrRemove = false;
//    var id = parseInt($(ovo).attr('id').slice(9));
//    var wishlist = Cookies.getJSON('wishlist');
//    if( $(ovo).is(':checked')  )
//    {
//        if(!wishlist)
//        {
//            wishlist  = [];
//            wishlist.push( id);
//        }
//        else
//        {
//            if( $.inArray( id, wishlist ))
//            {
//                wishlist.push(id)
//            }
//        }
//        addOrRemove = true;
//        $(".WishlistBtn").show();
//        $(".WishlistBtn" ).animate({
//            opacity: 1,
//            left: "0",
//        }, 1000, function() {});
//
//    }
//    else
//    {
//        if (!Array.prototype.remove)
//        {
//            Array.prototype.remove = function(val)
//            {
//                var i = this.indexOf(val);
//                return i>-1 ? this.splice(i, 1) : [];
//            };
//        }
//
//        if( $('.wishlistMainContainerClass').length )
//        {
//            $('*[data-hover="'+id+'"]').remove();
//        }
//
//        wishlist.remove(id);
//        if(wishlist.length == 0)
//        {
//            //$('.WishlistBtn').hide();
//            $( ".WishlistBtn" ).animate({
//                opacity: 1,
//                left: "-60",
//            }, 1000, function() {});
//        }
//        addOrRemove = false;
//
//    }
//
//
//    if($(ovo).attr('id').slice(0,8) == 'wishlisr'  )
//    {
//        $('#wishlist-'+id).prop('checked', addOrRemove);
//    }
//
//    Cookies.set('wishlist',wishlist,{expires:365});
//    $.wishlist = Cookies.getJSON('wishlist');
//}
function wishlistTotalCount()
{
    var wishlist      = Cookies.getJSON('wishlist');
    var wishlistFirms = Cookies.getJSON('wishlistFirms');
    var total = 0 ;
    if(typeof wishlist != 'undefined')
    {
        total += wishlist.length;
    }
    if(typeof wishlistFirms != 'undefined')
    {
        total += wishlistFirms.length;
    }

    if(total > 0)
    {
        $('#wishlistCounter').html(total);
    }
    else
    {
        $('#wishlistCounter').html('');
    }
}

function wishlist(ovo)
{
    var type = 'apartment';
    var wishlistName = 'wishlist';
    if(typeof $(ovo).data().type != 'undefined' && $(ovo).data().type  != '')
    {
        type = $(ovo).data().type;
        var wishlistName = 'wishlistFirms';
    }


    var addOrRemove = false;
    var id = parseInt($(ovo).attr('id').slice(9));
    var wishlist = Cookies.getJSON(wishlistName);


    if( $(ovo).is(':checked')  )
    {
        if(!wishlist)
        {
            wishlist  = [];
            wishlist.push( id);
        }
        else
        {
            if( $.inArray( id, wishlist ))
            {
                wishlist.push(id)
            }
        }
        addOrRemove = true;
        $(".WishlistBtn").show();
        $(".WishlistBtn" ).animate({
            opacity: 1,
            left: "0",
        }, 1000, function() {});

    }
    else
    {
        if (!Array.prototype.remove)
        {
            Array.prototype.remove = function(val)
            {
                var i = this.indexOf(val);
                return i>-1 ? this.splice(i, 1) : [];
            };
        }

        // on wishlist page remove it
        if( $('.wishlistMainContainerClass').length )
        {
            if(type == 'apartment')
            {
                $('*[data-hover="'+id+'"]').hide('slow', function() {
                  $('*[data-hover="'+id+'"]').remove();
                });
                deleteMarker(id)
            }
            else
            {
                $('*[data-hoverfirm="'+id+'"]').hide('slow', function() {
                  $('*[data-hoverfirm="'+id+'"]').remove();
                });
                deleteMarkerFirms(id)
            }
        }

        wishlist.remove(id);

        addOrRemove = false;

    }

    if(type!='apartment')
    {
        var cb = $('*[data-contactbutton="'+id+'"]');
        var cbSpan =$('*[data-contactbutton="'+id+'"] span.txtC');

        if( cb.hasClass('cta-blue') )
        {
            //
            cb.removeClass('cta-blue');
            cb.addClass('cta-blue-invert');
            if( $('body').data().lang == 'sr')
            {
                cbSpan.html('ukloni iz omiljenih')
            }
            else
            {
                cbSpan.html('remove from Wish List')
            }
        }
        else
        {
            cb.removeClass('cta-blue-invert');
            cb.addClass('cta-blue');
            if($('body').data().lang== 'sr')
            {
                cbSpan.html('dodaj u omiljene')
            }
            else
            {
                cbSpan.html('add to Wish List')
            }

        }
    }


    if($(ovo).attr('id').slice(0,8) == 'wishlisr'  )
    {
        $('#wishlist-'+id).prop('checked', addOrRemove);
    }



    Cookies.set( wishlistName , wishlist,{expires:365});


    $.wishlist      = Cookies.getJSON('wishlist');
    $.wishlistFirms = Cookies.getJSON('wishlistFirms');
    if(
        ($.wishlist && $.wishlist.length ==0 ) && ($.wishlistFirms && $.wishlistFirms.length ==0)
    )
    {
        $( ".WishlistBtn" ).animate({
            opacity: 1,
            left: "-60",
        }, 1000, function() {});
    }

    wishlistTotalCount();
}


function wishlistClearAll()
{
    var wishlist  = [];
    Cookies.set('wishlist',wishlist,{expires:365});
    $.wishlist = Cookies.getJSON('wishlist');

    var wishlistFirms  = [];
    Cookies.set('wishlistFirms',wishlistFirms,{expires:365});
    $.wishlistFirms = Cookies.getJSON('wishlistFirms');

    wishlistTotalCount();
}


function wishlistClearAllConfirm()
{
    const translations = {
      sr: {
          title: 'Da li ste sigurni da želite da obrišete?',
          text: "Ukoliko obrišete listu omiljenih mesta biće zauvek obrisana",
          confirmButtonText: 'Da, obriši',
          cancelButtonText: 'Ne, odustani',
          listDeleted: 'Lista omiljenih mesta je obrisana!',
          refreshMessage: 'Stranica će se sama osvežiti za 3 sekunde',
          listNotDeleted: 'Lista nije obrisana',
          listSaved: 'Vaša lista omiljenih mesta je sačuvana'
      },
      en: {
          title: 'Are you sure you want to delete?',
          text: "If you delete your list of favorite places, it will be permanently deleted",
          confirmButtonText: 'Yes, delete',
          cancelButtonText: 'No, cancel',
          listDeleted: 'List of favorite places deleted!',
          refreshMessage: 'The page will refresh in 3 seconds',
          listNotDeleted: 'List not deleted',
          listSaved: 'Your list of favorite places is saved'
      }
    };

    swal({
        title: translations[window.currentLocale || 'sr'].title,
        text: translations[window.currentLocale || 'sr'].text,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: translations[window.currentLocale || 'sr'].confirmButtonText,
        cancelButtonText: translations[window.currentLocale || 'sr'].cancelButtonText,
    }).then(function() {
        wishlistClearAll();
        swal({
            title: translations[window.currentLocale || 'sr'].listDeleted,
            text: translations[window.currentLocale || 'sr'].refreshMessage,
            type: "success"
        });
        setTimeout(function() {
            location.reload();
        }, 3000);
    }).catch(function() {
        swal({
          title: translations[window.currentLocale || 'sr'].listNotDeleted,
          text: translations[window.currentLocale || 'sr'].listSaved,
          type: "error"
        });
    });
}








/* --------------------------------------------------
 :: Track Referrers UTM to cookie
 -------------------------------------------------- */

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

$(function() {
    //Cookies.set( wishlistName , wishlist,{expires:365});
    if (Cookies('myapp_referrer') == null || Cookies('myapp_referrer') == "" )
    {
        Cookies('myapp_referrer', document.referrer, { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

    if (getParameterByName('utm_source') !== "")
    {
        Cookies('utm_source', getParameterByName('utm_source'), { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

    if (getParameterByName('utm_medium') !== "")
    {
        Cookies('utm_medium', getParameterByName('utm_medium'), { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

    if (getParameterByName('utm_term') !== "")
    {
        Cookies('utm_term', getParameterByName('utm_term'), { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

    if (getParameterByName('utm_content') !== "")
    {
        Cookies('utm_content', getParameterByName('utm_content'), { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

    if (getParameterByName('utm_campaign') !== "")
    {
        Cookies('utm_campaign', getParameterByName('utm_campaign'), { expires: 180});
        //, path: '/', domain: 'apartmani-u-beogradu.com', secure: true
    }

});



// Submit Forms

// Register
//$('#modalSubmitRegister').click(function(e) {
//    e.preventDefault();
//
//    $.ajax({
//        type: "POST",

//        url: 'some_route',
//        data: $("modal-form-register").serialize(),
//        success: function(data)
//        {
//            alert(data); // show response from the php script.
//        }
//    });
//});

//$( ".dropdown-multi" ).hover(
//    function()
//    {
//        $(this).addClass('open');
//    },
//    function()
//    {
//        $(this).removeClass('open');
//    }
//);
//
//$(document).ready(function()
//{
//    $( ".dropdown-multi" )
//        .mouseenter(function()
//        {
//            $(this).parent('li').addClass('active');
//        })
//        .mouseleave(function()
//        {
//            $(this).parent('li').removeClass('active');
//        });
//});

$(document).ready(function() {
    $(".fancybox").fancybox();
});

$( "#search_form" ).submit(function( event )
{
    event.preventDefault();
    var lang = $(this).data('lang');

    var city     = $('#city').val();

    var url = (lang == 'sr' ? '/apartmani-' : '/en/apartments-' )+city;

    var guests = $('#guests').val();
    var checkin  = $('#checkinBig').val();
    var checkout = $('#checkoutBig').val();
    var myParams = {};
    if(checkin && checkout){
        myParams.checkin = checkin;
        myParams.checkout = checkout;
    }
    if(guests){
        myParams.guests = guests;
    }
    if( (checkin && checkout) || guests){
        myParams.instant = 1;
    }

    if($.param(myParams)){
        url += '?'+$.param(myParams);
    }
    window.location = url;
});

$("#search-form--sm").submit(function(event)
{
    $(this).attr('action', $('#chooseCity').val())
});
//  $('#chooseCity').on('change',function()
//  {
//     // call ajax to get areas
//     window.location =  $(this).val();
// });

// AUTOCOMPLETE
$( function() {
     $.widget( "custom.catcomplete", $.ui.autocomplete, {
      _create: function() {
        this._super();
        this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
      },
      _renderMenu: function( ul, items ) {
        var that = this,
          currentCategory = "";
        $.each( items, function( index, item ) {
          var li;
          if ( item.category != currentCategory ) {
            ul.append( "<li class='ui-autocomplete-category'>" + item.category + "</li>" );
            currentCategory = item.category;
          }
          li = that._renderItemData( ul, item );
          if ( item.category ) {
            li.attr( "aria-label", item.category + " : " + item.label );
          }
        });
      },
     _renderItem : function (ul, item) {
         var icon = 'fa-map-marker';
         if(item.category.toLowerCase() == 'apartmani' || item.category.toLowerCase() == 'apartments' ){
             icon = 'fa-home'
         }
         return $('<li class="ui-menu-item-with-icon"></li>')
             .data("item.autocomplete", item)
             .append('<a><i class="fa ' + icon + '"></i>' + item.label + '</a>')
             .appendTo(ul);
     }
    });
    var lang = 'sr';
    if( $('body').data().lang == 'sr' || $('body').data().lang == 'en'){
        lang = $('body').data().lang;
    }

    $( "#autocomplete" ).catcomplete({
      source: "/autocomplete?lang="+lang,
      minLength: 2,
      select: function( event, ui )
      {
        window.location = ui.item.url;
      }
    });
  } );

$(document).ready(function() {
    $(".firms-dropdown").hover(function(){
        $('body').toggleClass("no-scroll");
    });
    $('.prevent-trigger').on('click', function(e) {
        e.preventDefault();
    });
});


$(document).ready(function(){
    if($('.links-slider')[0]){
        $('.links-slider').slick({
            infinite: true,
            dots: true,
            speed: 700,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings:
                    {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings:
                    {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                    }
                }
            ]
        });
    }
});
$( function() {
    // TOGGLE MENU
    $('.dropdown-toggle').dropdown();

 });

 $(document).on('click', '.dropdown-menu', function (e) {
    e.stopPropagation();
});

// Treba da se doda samo na stranicama sa novim filterima
$(document).on('click', '.ui-datepicker-header, .ui-datepicker-calendar', function (e) {
    e.stopPropagation();
});


$(document).on('click', '.fm-close-btn', function (e) {
    e.stopPropagation();
    $('.dropdown.open .dropdown-toggle').dropdown('toggle');
});

$('.remove-account-btn').on('click', function() {
  const rm_acc_translations = {
    sr: {
      title: 'Da li ste sigurni?',
      text: 'Da li ste sigurni da želite da zatražite brisanje naloga?',
      confirmButtonText: 'Da',
      cancelButtonText: 'Ne',
      listDeleted: 'Vaš nalog će biti obrisan, poslali smo vam email o potvrdi brisanja. Obavestićemo vas kada vaš nalog bude obrisan.',
      deleteError: 'Došlo je do greške prilikom brisanja naloga. Pokušajte ponovo kasnije.',
      pleaseWait: 'Molimo sačekajte...',
    },
    en: {
      title: 'Are you sure?',
      text: 'Are you sure you want to request deletion of your account?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      listDeleted: 'Your account will be deleted, we have sent you a confirmation email. We will inform you once your account has been deleted.',
      deleteError: 'An error occurred while attempting to delete the account. Please try again later.',
      pleaseWait: 'Please wait...',
    }
  }

  const deleteUrl = $('.remove-account-btn').data('url');

  swal({
    title: rm_acc_translations[window.currentLocale || 'sr'].title,
    text: rm_acc_translations[window.currentLocale || 'sr'].text,
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#DD6B55",
    confirmButtonText: rm_acc_translations[window.currentLocale || 'sr'].confirmButtonText,
    cancelButtonText: rm_acc_translations[window.currentLocale || 'sr'].cancelButtonText,
  }).then(function() {
      swal({
        title: rm_acc_translations[window.currentLocale || 'sr'].pleaseWait,
        type: "info"
      });
      $.ajax({
        url: deleteUrl,
        type: 'POST',
        success: function(result) {
          swal({
            title: rm_acc_translations[window.currentLocale || 'sr'].listDeleted,
            text: rm_acc_translations[window.currentLocale || 'sr'].refreshMessage,
            type: "success"
          });
          var redirectTimeout = setTimeout(function() {
            window.location = '/'+ (window.currentLocale === 'en' ? window.currentLocale : '');
            clearTimeout(redirectTimeout);
          }, 3000);
        },
        error: function(status, error) {
          swal("Oops...", rm_acc_translations[window.currentLocale || 'sr'].deleteError , "error");
        }
      });
  }).catch(function() {
      swal({
        title: rm_acc_translations[window.currentLocale || 'sr'].listNotDeleted,
        text: rm_acc_translations[window.currentLocale || 'sr'].listSaved,
        type: "error"
      });
  });
});

$(document).ready(function() {
  if (
    (window.navigator
    && window.navigator.userAgent
    && window.navigator.userAgent.includes('cordova-app'))
    || window.cordova_iab
  ) {
    $('body').addClass('cordova-app');
  }

  if (
    window.navigator
    && window.navigator.userAgent
    && window.navigator.userAgent.includes('cordova-app-ios')
  ) {
    $('body').addClass('cordova-app-ios');
  }

  if (window.navigator && window.navigator.userAgent) {
    const isCordovaApp = ($('body').hasClass('cordova-app') || $('body').hasClass('cordova-app-ios'));
    const isMobileWebUser = (/android|iphone|ipod|ipad|phone|mobile/i.test(window.navigator.userAgent) && !isCordovaApp);
    const isiOSWebUser = (/iphone|ipod|ipad/i.test(window.navigator.userAgent));
    const isAppPromoAlertShown = localStorage.getItem('appPromoAlertShown');
    if (isMobileWebUser && !isAppPromoAlertShown) {
      $('.get-our-app-alert').removeClass('hide');
      $('body').addClass('app-promo-alert-shown');
    }
    $('.get-our-app-alert-close').on('click', function() {
      $('.get-our-app-alert').addClass('hide');
      $('body').removeClass('app-promo-alert-shown');
      localStorage.setItem('appPromoAlertShown', 'true');
    });
    $('.app-download-button').on('click', function() {
      if (isiOSWebUser) {
        window.open('https://apps.apple.com/sk/app/apartmani-u-beogradu/id6480404323', '_blank');
      } else {
        window.open('https://play.google.com/store/apps/details?id=com.apartmaniubeogradu.app', '_blank');
      }
    });
  }


  // START OF BLACK FRIDAY DEAL COUNTDOWN TIMER
  // var countdownEl = $(".countdown-black-friday-end");
  // if (countdownEl.length) {
  //   var countdownSecond = 1000,
  //       countdownMinute = countdownSecond * 60,
  //       countdownHour = countdownMinute * 60,
  //       countdownDay = countdownHour * 24;

  //   var countdownInterval;

  //   var blackFridayEnd = new Date('2025-01-01T00:00:00').getTime();

  //   var updateTimer = function () {
  //     var countdownNow = new Date().getTime();
  //     var countdownDistance = blackFridayEnd - countdownNow;

  //     if (countdownDistance < 0) {
  //       countdownEl.hide();
  //       clearInterval(countdownInterval);
  //       return;
  //     }

  //     var countdownDaysEl = $('.countdown-days');
  //     var countdownHoursEl = $('.countdown-hours');
  //     var countdownMinutesEl = $('.countdown-minutes');
  //     var countdownSecondsEl = $('.countdown-seconds');

  //     if (countdownDaysEl.length) {
  //       countdownDaysEl.text(Math.floor(countdownDistance / countdownDay));
  //     }
  //     if (countdownHoursEl.length) {
  //       countdownHoursEl.text(Math.floor((countdownDistance % countdownDay) / countdownHour));
  //     }
  //     if (countdownMinutesEl.length) {
  //       countdownMinutesEl.text(Math.floor((countdownDistance % countdownHour) / countdownMinute));
  //     }
  //     if (countdownSecondsEl.length) {
  //       countdownSecondsEl.text(Math.floor((countdownDistance % countdownMinute) / countdownSecond));
  //     }
  //   };

  //   updateTimer();

  //   countdownInterval = setInterval(updateTimer, countdownSecond);
  // }
  // END OF BLACK FRIDAY DEAL COUNTDOWN TIMER
});
